import React, { useContext, useEffect, useState, useRef } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { Text } from 'rebass'
import { useActiveWeb3React } from '../../hooks'
import { BIGNUMBER_FMT } from '../../constants/bakery'
import { BigNumber } from 'bignumber.js'
import { CONTRACT_ADDRESSES } from '../../constants/api'
import { ExternalLink } from '../../theme'
import useYam from '../../hooks/bakery/useYam'

import { AuctionBake } from '../../constants/artwork'

import { getEvents } from '../../service/nft'
import { MARKETTYPE, MARKETTYPEV1, MARKETTYPEV3, MARKETMULTITOKEN } from '../../constants/bakery/nft'

import { contractAddresses } from '../../sushi/lib/constants'
import { userTokenName } from '../../userType/userTokenName'
import { userTokenDecimals } from '../../userType/userTokenDecimals'
import { getSushiAddress } from '../../sushi/utils'

const Box = styled.div`
  padding: 24px;
  width: 610px;
  background: ${({ theme}) => theme.bsBg41};
  box-shadow: ${({ theme}) => theme.boxShadow1};
  border-radius: 11px;
  table{
    width: 100%;
    border:0;
    margin:0;
    border-collapse:collapse;
    border-spacing:0;
    font-size: 14px;
    font-weight: 700;
    .first {
      width: 100px;
      max-width: 120px;
      div {
        overflow: hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
      }
    }
    .second {
      width: 115px;
      max-width: 120px;
      div {
        overflow: hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
      }
    }
    .third {
      width: 125px;
    }
    .four {
      width: 125px;
    }
    .five {
      padding-right: 19px;
      text-align: right;
    }
    td {
      div {
        line-height: 20px;
        white-space: nowrap;
      }
      &:first-child{
        padding-left: 19px;
      }
    }
    thead{
      background: ${({ theme}) => theme.bsBg42};
      font-weight: normal;
      td{
        height: 32px;
        line-height: 32px;
        &:first-child{
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;
        }
        &:last-child{
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
        }
      }
    }
    tbody{
      tr{
        /* border-bottom: 1px solid #F7E4CE; */
        td{
          height: 56px;
          line-height: 56px;
          font-family: Yuanti SC;
        }
      }
      .nothing{
        text-align: center;
        border-bottom: none;
        td {
          padding: 30px 0;
          height: auto;
          line-height: 0;
        }
      }
    }
  }
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 100%;
    margin-top: 40px;
  `}
`
const ListTable = styled.div`
  width: 562px;
  max-height: 280px;
  overflow-y: scroll;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 100%;
  `}
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
  `}
`
const infiniteStyle = {
  width: '562px',
  maxHeight: '280px',
  overflowY: 'auto'
};
const AboutLink = styled(ExternalLink)`
  color: ${({ theme}) => theme.darkMode ? '#C1B6A8' : theme.bsText3};
  font-weight: bold;
  text-decoration: none;
  font-family: Yuanti SC;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-left: 0;
    margin-right: 8px;
  `};
`

export const BAKERYARTWORK = 'BAKERYARTWORK'
export const SEASCAPE = 'SEASCAPE'
export const MEME = 'MEME'
export const MUSKDOGE = 'MUSKDOGE'
export const ONEINCHS = 'ONEINCHS'
export const ARTWORK = 'ARTWORK'
export const BAKERYSOCCER = 'BAKERYSOCCER'
export const TKONFT = 'TKONFT'

// 无限滚动组件
function InfiniteScroll(props:any) {
  const { 
      style,  // 一定要设置 overflow: auto, 以及一定要设置元素的高, 让容器出现滚动条, 
      children,
      disabled,
      load,
      distance = 0, // 距离底部多少px时开始加载，0表示滚动到最底部时开始加载
  } = props;

  const refList = useRef();
  const onScroll = () => {
      if (disabled) {
          return;
      }
      const element:HTMLElement = refList.current!;
      const scrollHeight = element.scrollHeight;
      const scrollTop = element.scrollTop;
      const clientHeight = element.clientHeight;
      if ((clientHeight + scrollTop + distance) >= scrollHeight) {
          load();
      }
  };

  return (
      <div style={style} ref={refList as any} onScroll={onScroll}>
          {children}
      </div>
  );
}

// utils
function dealToken (address: any) {
  if (address) {
    // return address.substring(0, 8) + '...' + address.substring(34)
    return address.substring(0, 4) + '...' + address.substring(38)
  }
  return '-'
}

function dealEventText (text: string, price?: string, decimals?: number) {
  let newText = ''
  let num = 0
  if (price && +price > 0) {
    num = new BigNumber(price).div(new BigNumber(10).pow(decimals || 18)).toNumber()
  }
  switch (text) {
    case 'CancelBidToken':
      newText = 'CancelBid'
      break
    case 'CancelSellToken':
      if (num === AuctionBake) {
        newText = 'CancelAuction'
      } else {
        newText = 'CancelSell'
      }
      break
    case 'Ask':
      if (num === AuctionBake) {
        newText = 'Auction'
      } else {
        newText = 'List'
      }
      break
    default:
      newText = text
  }
  return newText
}

function getTimer (stringTime: any){
  const second = 1000;
  const minute = 1000 * 60;
  const hour = minute *60;
  const day = hour *24;
  const week = day * 7;
  const month = day * 30;
  var time1 = new Date().getTime();//当前的时间戳
  var time2 = stringTime * 1000; //指定时间的时间戳
  var time = time1 - time2;

  var result = null;
  if(time < 0){
      result = '-'
      // alert("设置的时间不能早于当前时间！");
  }else if(time/month >= 1){
    result = new BigNumber(time/month).integerValue() + " months ago";
  }else if(time/week >= 1){
    result = new BigNumber(time/week).integerValue() + " weeks ago";
  }else if(time/day >= 1){
    result = new BigNumber(time/day).integerValue() + " days ago";
  }else if(time/hour >= 1){
    result = new BigNumber(time/hour).integerValue() + " hours ago";
  }else if(time/minute >= 1){
    result = new BigNumber(time/minute).integerValue() + " minutes ago";
  } else if (time/second >= 1) {
    result = new BigNumber(time/second).integerValue() + " seconds ago";
  } else {
      result = "-";
  }
  return result
}

export default function TradingList ({type, nftId, updateNum, tokenName, level}: {type?: string, nftId?: string, updateNum?: number, tokenName?: string, level?: string}) {
  const sushi = useYam()
  const theme = useContext(ThemeContext)
  const { chainId } = useActiveWeb3React()
  const bscLink = CONTRACT_ADDRESSES.bscApi[chainId as number]
  const [list, setList] = useState([])
  const [offset, setOffset] = useState(0)
  const [scrollLoadDisabled, setScrollLoadDisabled] = useState(false)
  const [loading, setLoading] = useState(false)
  let contractId: {[chainId: string]: string} = {}
  let address: {[chainId: string]: string} = {}
  let address2: {[chainId: string]: string} = {}
  let isMultiToken = false
  let decimals = userTokenDecimals(tokenName)
  let addressV3: {[chainId: string]: string} = {}
  let defaultSymbol: any = ''
  switch (type) {
    case MARKETTYPEV3.WEAPONNFTV3:
    case MARKETTYPE.WEAPONNFT:
    case MARKETTYPEV1.WEAPONNFTV1:
      contractId = contractAddresses.weaponNFT
      if (level === 'v1') {
        address = contractAddresses.exchangeWeaponNFT
      } else {
        address = contractAddresses.bidWeaponNFT
      }
      break
    case MARKETTYPEV3.PETNFTV3:
    case MARKETTYPE.PETNFT:
    case MARKETTYPEV1.PETNFTV1:
      contractId = contractAddresses.petNft
      if (level === 'v1') {
        address = contractAddresses.exchangePetNft
      } else {
        address = contractAddresses.bidPetNFT
      }
      break
    case MARKETTYPEV3.EGGNFTV3:
    case MARKETTYPE.EGGNFT:
    case MARKETTYPEV1.EGGNFTV1:
      contractId = contractAddresses.petEggNft
      if (level === 'v1') {
        address = contractAddresses.exchangeEggNFT
      } else {
        address = contractAddresses.bidPetEggNFT
      }
      break
    case MARKETTYPEV3.DISHV3:
    case MARKETTYPE.DISH:
    case MARKETTYPEV1.DISHV1:
      contractId = contractAddresses.dish
      if (level === 'v1') {
        address = contractAddresses.exchangeNFT
      } else {
        address = contractAddresses.bidDishNFT
      }
      break
    case BAKERYARTWORK:
    case MARKETTYPEV1.BAKERYARTWORKV1:
    case MARKETTYPEV3.BAKERYARTWORKV3:
      defaultSymbol = getSushiAddress(sushi)
      contractId = contractAddresses.bakeryArtworkNFT
      if (level === 'v1') {
        address = contractAddresses.exchangeBakeryArtworkNFT
      } else {
        address = contractAddresses.bidBakeryArtworkNFT
      }
      break
    case SEASCAPE:
    case MARKETTYPEV1.SEASCAPEV1:
    case MARKETTYPEV3.SEASCAPEV3:
      contractId = contractAddresses.seascapeNFT
      if (level === 'v1') {
        address = contractAddresses.exchangeSeascapeNFT
      } else {
        address = contractAddresses.bidSeascapeNFT
      }
      break
    case ARTWORK:
    case MARKETTYPEV1.ARTWORKV1:
    case MARKETTYPEV3.ARTWORKV3:
      contractId = contractAddresses.digitalArtworkNft
      if (level === 'v1') {
        address = contractAddresses.exchangeArtworkNFT
      } else {
        address = contractAddresses.bidDigitalArtworkNFT
      }
      break
    case ONEINCHS:
    case MARKETTYPEV1.ONEINCHV1:
    case MARKETTYPEV3.ONEINCHV3:
      contractId = contractAddresses.oneInchBakeNFT
      if (level === 'v1') {
        address = contractAddresses.exchangeOneInchBakeNFT
      } else {
        address = contractAddresses.bidOneInchBakeNFT
      }
      break
    case MEME:
    case MARKETTYPEV1.MEMEV1:
    case MARKETTYPEV3.MEMEV3:
      contractId = contractAddresses.bakeryArtwork3NFT
      if (level === 'v1') {
        address = contractAddresses.exchangeBakeryArtwork3NFT
      } else {
        address = contractAddresses.bidBakeryArtwork3NFT
      }
      break
    case MUSKDOGE:
    case MARKETTYPEV1.MUSKDOGEV1:
    case MARKETTYPEV3.MUSKDOGEV3:
      contractId = contractAddresses.bakeryArtwork2NFT
      if (level === 'v1') {
        address = contractAddresses.exchangeBakeryArtwork2NFT
      } else {
        address = contractAddresses.bidBakeryArtwork2NFT
      }
      break
    case BAKERYSOCCER:
    case MARKETTYPEV1.BAKERYSOCCERV1:
    case MARKETTYPEV3.BAKERYSOCCERV3:
      contractId = contractAddresses.bakerySoccer
      if (level === 'v1') {
        address = contractAddresses.exchangeBakerySoccer
      } else {
        address = contractAddresses.bidBakerySoccer
      }
      break
    case TKONFT:
    case MARKETTYPEV1.TKONFTV1:
    case MARKETTYPEV3.TKONFTV3:
      contractId = contractAddresses.tokocryptoNft
      if (level === 'v1') {
        address = contractAddresses.exchangeTokocryptoNFT
      } else {
        address = contractAddresses.bidTokocryptoNFT
      }
      break
    case MARKETTYPE.SFPARTWORK:
    case MARKETTYPEV1.SFPARTWORKV1:
    case MARKETTYPEV3.SFPARTWORKV3:
      contractId = contractAddresses.sfpNFT
      if (level === 'v1') {
        address = contractAddresses.exchangeSfpNFT
      } else {
        address = contractAddresses.bidSfpNFT
      }
      break
    case MARKETTYPE.DOGGYNFT:
    case MARKETTYPEV1.DOGGYNFTV1:
    case MARKETTYPEV3.DOGGYNFTV3:
      contractId = contractAddresses.doggyNFT
      if (level === 'v1') {
        address = contractAddresses.exchangeDoggyNFT
      } else {
        address = contractAddresses.bidDoggyNFT
      }
      break
    case MARKETTYPE.LOVE:
    case MARKETTYPEV1.LOVEV1:
    case MARKETTYPEV3.LOVEV3:
      contractId = contractAddresses.loveNFT
      if (level === 'v1') {
        address = contractAddresses.exchangeLoveNFT
      } else {
        address = contractAddresses.bidLoveNFT
      }
      break
    case MARKETTYPE.BARKNFT:
    case MARKETTYPEV1.BARKNFTV1:
    case MARKETTYPEV3.BARKNFTV3:
      contractId = contractAddresses.barkingNFT
      if (level === 'v1') {
        address = contractAddresses.exchangeBarkingNFT
      } else {
        address = contractAddresses.bidBarkingNFT
      }
      break
    case MARKETTYPE.YOOSHINFT:
    case MARKETTYPEV1.YOOSHINFTV1:
    case MARKETTYPEV3.YOOSHINFTV3:
      contractId = contractAddresses.yooshiNFT
      if (level === 'v1') {
        address = contractAddresses.exchangeYooshiNFT
      } else {
        address = contractAddresses.bidYooshiNFT
      } 
      break
    case MARKETTYPE.RACANFT:
    case MARKETTYPEV1.RACANFTV1:
    case MARKETTYPEV3.RACANFTV3:
      contractId = contractAddresses.racaNFT
      if (level === 'v1') {
        address = contractAddresses.exchangeRacaNFT
      } else {
        address = contractAddresses.exchangeNFTs
        address2 = contractAddresses.bidRacaNFT
        isMultiToken = true
      }
      break
    case MARKETTYPE.BONDLYNFT:
    case MARKETTYPEV1.BONDLYNFTV1:
    case MARKETTYPEV3.BONDLYNFTV3:
      contractId = contractAddresses.bondlyNft
      if (level === 'v1') {
        address = contractAddresses.exchangeBondlyNFT
      } else {
        address = contractAddresses.bidBondlyNFT
      }
      break
    case MARKETTYPE.BAKERYBSCARTWORK:
    case MARKETTYPEV1.BAKERYBSCARTWORKV1:
    case MARKETTYPEV3.BAKERYBSCARTWORKV3:
      defaultSymbol = getSushiAddress(sushi)
      contractId = contractAddresses.bscBakeNFT
      if (level === 'v1') {
        address = contractAddresses.exchangeBscBakeNFT
      } else {
        address = contractAddresses.bidBscBakeNFT
      }
      break
    case MARKETMULTITOKEN.EQUIPMENTMULTITOKEN:
    case MARKETTYPEV3.EQUIPMENTV3:
      contractId = contractAddresses.doggyEquipment
      address = contractAddresses.exchangeNFTs
      break
    case MARKETMULTITOKEN.POKERMULTITOKEN:
    case MARKETTYPEV3.POKERCARDV3:
      contractId = contractAddresses.pokerCard
      address = contractAddresses.exchangeNFTs
      break
    case MARKETMULTITOKEN.MATRIXMULTITOKEN:
    case MARKETTYPEV3.MATRIXV3:
      contractId = contractAddresses.matrixPlusBox
      address = contractAddresses.exchangeNFTs
      break
    case MARKETMULTITOKEN.TOYMULTITOKEN:
    case MARKETTYPEV3.TOYV3:
      contractId = contractAddresses.toys
      address = contractAddresses.exchangeNFTs
      break
    case MARKETMULTITOKEN.KAKAMULTITOKEN:
    case MARKETTYPEV3.KAKAV3:
      contractId = contractAddresses.ktaNFT
      address = contractAddresses.exchangeNFTs
      break
    case MARKETMULTITOKEN.BAKEMUSKMIXERMULTITOKEN:
    case MARKETTYPEV3.BAKEMUSKV3:
      contractId = contractAddresses.bakeMuskMixer
      address = contractAddresses.exchangeNFTs
      break
    case MARKETMULTITOKEN.TOKAUMULTITOKEN:
      case MARKETTYPEV3.TOKAUV3:
        contractId = contractAddresses.tokauNFT
        address = contractAddresses.exchangeNFTs
        break
    case MARKETTYPEV3.MUSKUSMLANDNFTV3:
      contractId = contractAddresses.muskUsmLand
      address = contractAddresses.exchangeNFTs
      break
    case MARKETTYPEV3.BLINV3:
      contractId = contractAddresses.newDonghuangArt
      address = contractAddresses.exchangeNFTs
      break
    case MARKETTYPEV3.BINAMONV3:
      contractId = contractAddresses.bmonc
      address = contractAddresses.exchangeNFTs
      break
    case MARKETTYPEV3.GAV3:
      contractId = contractAddresses.ga
      address = contractAddresses.exchangeNFTs
      break
    case MARKETTYPEV3.KTAV3:
      contractId = contractAddresses.kTreasureAdvanced
      address = contractAddresses.exchangeNFTs
      break
    case MARKETTYPEV3.KRBV3:
      contractId = contractAddresses.kRabbit
      address = contractAddresses.exchangeNFTs
      break
    case MARKETTYPEV3.KRIPTOMONV3:
      contractId = contractAddresses.kmoNFT
      address = contractAddresses.exchangeNFTs
      break
  }

  if (level === 'v3') {
    addressV3 = contractAddresses.exchangeNFTs2
  }
  let addressParam = address[chainId as number] + (level === 'v3' ? ',' + addressV3[chainId as number] : '')
  if(isMultiToken){
    addressParam = [address[chainId as number],address2[chainId as number]].join(",") + (level === 'v3' ? ',' + addressV3[chainId as number] : '')
  }
  let params = {
      sortName: 'time',
      nftAddress: contractId[chainId as number],
      addresses: addressParam,
      nftId: nftId,
      limit: 100,
      offset: offset
    }
  

  const onLoadEvents = () => {
    if (scrollLoadDisabled && loading) {
      return;
    }
    setLoading(true)
    setScrollLoadDisabled(true)
    getEvents(chainId as number, params, (err: any, res: any) => {
      setLoading(false)
      if (err || res.code !== 0) return
      const data: [] = res.data.list || []
      setOffset(offset => offset + data.length)
      data.map((d: any) => {
        d.detail.quoteToken = d.detail.quoteToken || defaultSymbol
      })
      setList(list.concat(data))
      setScrollLoadDisabled(false)
      if (data.length < params.limit) {
        setScrollLoadDisabled(true)
      }
    })
  }

  const updateEvents = () => {
    if (scrollLoadDisabled && loading) {
      return;
    }
    setLoading(true)
    setScrollLoadDisabled(true)
    getEvents(chainId as number, params, (err: any, res: any) => {
      setLoading(false)
      if (err || res.code !== 0) return
      const data: [] = res.data.list || []
      data.map((d: any) => {
        d.detail.quoteToken = d.detail.quoteToken || defaultSymbol
      })
      setOffset(data.length)
      setList(data)
      setScrollLoadDisabled(false)
      if (data.length < params.limit) {
        setScrollLoadDisabled(true)
      }
    })
  }

  useEffect(() => {
    if (nftId) {
      params.offset = 0
      setOffset(offset => offset - offset)
      updateEvents()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nftId, updateNum])

  // 因为api同步数据延迟，10秒后再次刷新列表
  // useEffect(() => {
  //   setTimeout(() => {
  //     if (nftId) {
  //       updateEvents()
  //     }
  //   }, 10000)
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [nftId, updateNum])

  return (
    <Box>
      <Text  color={theme.bsText28} fontSize={20} fontFamily={'Roboto-Bold'} marginBottom={24}>Trading History</Text>
      <table>
        <thead>
          <tr>
            <td className='first'>
              <Text color={theme.bsText29}>Event</Text>
            </td>
            <td className='second'>
              <Text color={theme.bsText29}>Price</Text>
            </td>
            <td className='third'>
              <Text color={theme.bsText29}>From</Text>
            </td>
            <td className='four'>
              <Text color={theme.bsText29}>To</Text>
            </td>
            <td className='five'>
              <Text color={theme.bsText29}>Date</Text>
            </td>
          </tr>
        </thead>
      </table>
      <ListTable id="box">
        <InfiniteScroll 
          style={infiniteStyle}
          disabled={scrollLoadDisabled} 
          load={onLoadEvents}
          >
          <table>
            <tbody>
            {
              list.length > 0 ?
                list.map((d: any, i) => {
                  return (
                    <tr key={i}>
                      <td className='first'>
                        <Text color={theme.darkMode ? '#C1B6A8' : theme.bsText14} maxWidth={'100%'}>{dealEventText(d.event, d.detail.price, decimals)}</Text>
                      </td>
                      <td className='second'>
                        <Text color={theme.bsText38}>
                          <img src={'/images/bakery/icon_' + (d.detail.quoteToken ? userTokenName(sushi, d.detail.quoteToken) : false || tokenName || 'BAKE').toLocaleLowerCase() + '.svg'} width={19} height={19} style={{marginRight: '5px', marginBottom: '-5px'}} alt=""/>
                          {(+d.detail.price > 0 && new BigNumber(d.detail.price).div(new BigNumber(10).pow(d.detail.quoteToken ? userTokenDecimals(userTokenName(sushi, d.detail.quoteToken)) : false || decimals)).toNumber() !== AuctionBake) ?
                            new BigNumber(d.detail.price).div(new BigNumber(10).pow(d.detail.quoteToken ? userTokenDecimals(userTokenName(sushi, d.detail.quoteToken)) : false || decimals)).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT) : '-'
                          }
                        </Text>
                      </td>
                      <td className='third'>
                        <Text color={theme.bsText38}>
                          <AboutLink href={`${bscLink}/address/${ d.detail.seller ? d.detail.seller : d.from}`}>
                            { d.detail.seller ? dealToken(d.detail.seller) : dealToken(d.from) }
                          </AboutLink>
                        </Text>
                      </td>
                      <td className='four'>
                        <Text color={theme.bsText38}>
                          <AboutLink href={`${bscLink}/address/${d.to}`}>
                            { dealToken(d.to) }
                          </AboutLink>
                        </Text>
                      </td>
                      <td className="five">
                        <Text color={theme.bsText38}>{ getTimer(d.time) }</Text>
                      </td>
                    </tr>
                  )
                })
              :
                <tr className={'nothing'}>
                  <td colSpan={5}>
                    <img src="/images/bakery/icon_nothing_bid.svg" alt=""/>
                    <Text color={theme.bsText38} fontSize={14} marginTop={'10px'}>There's no trading history</Text>
                  </td>
                </tr>
            }
            </tbody>
          </table>
          {
            loading ?
            <Text
              marginTop={20} 
              textAlign={'center'} 
              fontFamily={'Baloo Da'}>
                loading...
            </Text>
            :null
          }
        </InfiniteScroll>
      </ListTable>
    </Box>
  )
}